import moment from 'moment'
import React, { Fragment } from 'react'
import { Table } from 'react-bootstrap'
import SpinningLoader from './SpinningLoader'
import Pagination from "./Pagination"
type Props = {
    data?: any,
    loading?: boolean,
    setFilterData?: (s: string) => void,
    filterData?: string,
    searchData?: string,
    fromDate?: string,
    toDate?: string,
    pageNumber?: number,
    totalRecords?: number,
    setPageNumber?: (s: number) => void,
    limit?: number,
}
const BigTableView = ({ data, totalRecords = 0, pageNumber = 1, setPageNumber = (s: number) => 1, loading, setFilterData = (s: string) => "", filterData, searchData, fromDate, toDate, limit = 8 }: Props) => {

    // const handlePrevBtn = () => {
    //     setPageNumber(pageNumber - 1)
    // }

    // const handleNextBtn = () => {
    //     setPageNumber(pageNumber + 1)
    // }

    return (
        <>
            <div style={{ marginBottom: '10px', backgroundColor: "#FFFFFF", textAlign: 'left', boxShadow: '0px 0px 44px #D9EDEF', paddingLeft: '10px', paddingRight: '10px' }} >
                {loading ?
                    <div style={{ height: '400px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'black' }} >
                        <SpinningLoader
                            isLoading
                        />
                    </div>
                    :
                    data?.length !== 0 ?
                        <>
                            <Table style={{ borderBottom: '1px solid #F2F2F2', textAlign: 'left' }} responsive>
                                <thead style={{ backgroundColor: '#F7F9FA', color: '#878CB9' }} >
                                    <tr>
                                        <th>Date</th>
                                        <th>Mr Name</th>
                                        <th>Zone Name</th>
                                        <th>Doctor’s Name</th>
                                        <th>Doctor’s City</th>
                                        <th>Q-1</th>
                                        <th>Q-2</th>
                                        <th>Q-3</th>
                                        <th>Q-4</th>
                                        <th>Q-5</th>
                                        <th>Q-6</th>
                                    </tr>
                                </thead>
                                <tbody style={{ color: 'black' }} >
                                    {
                                        data?.map((item: any, index: number) => {
                                            return (<Fragment key={index}>
                                                <tr>
                                                    {/* <td>{moment(item?.created_at).format("DD-MM-YYYY")}</td> */}
                                                    <td>{item?.content && JSON.parse(item?.content)?.date}</td>
                                                    <td>{item?.mr_name}</td>
                                                    <td>{item?.zone_name}</td>
                                                    <td>{item?.content && JSON.parse(item?.content)?.doctor_name}</td>
                                                    <td>{item?.content && JSON.parse(item?.content)?.doctor_city}</td>
                                                    <td>{item?.content && JSON.parse(item?.content)?.questions[0]?.ans}</td>
                                                    <td>{item?.content && JSON.parse(item?.content)?.questions[1]?.ans}</td>
                                                    <td>{item?.content && JSON.parse(item?.content)?.questions[2]?.ans}</td>
                                                    <td>{item?.content && JSON.parse(item?.content)?.questions[3]?.ans}</td>
                                                    <td>{item?.content && JSON.parse(item?.content)?.questions[4]?.ans}</td>
                                                    <td>{item?.content && JSON.parse(item?.content)?.questions[5]?.ans}</td>
                                                </tr>
                                            </Fragment>)
                                        })
                                    }
                                </tbody>
                            </Table>
                        </>
                        : <div className='w-full text-center p-5' ><span style={{ margin: 'auto', textAlign: 'center', color: '#828BA5', fontSize: '1.5rem' }} >No Data Found</span></div>
                }
                {!loading && <div style={{ display: 'flex', paddingBottom: '0px', alignItems: 'center', justifyContent: 'center' }} >
                    <Pagination
                        className="pagination-bar"
                        currentPage={pageNumber}
                        totalCount={totalRecords}
                        pageSize={limit}
                        onPageChange={(page: number) => setPageNumber(page)}
                    />
                </div>}
            </div>
        </>
    )
}

export default BigTableView
